import React, { lazy ,useState, useEffect} from "react";
import { BrowserRouter as Router ,Routes , Route  } from "react-router-dom";
const LoginRegisterComp = lazy(() => import("./pages/LoginRegister"));
const HealthAssessmentQuiz = lazy(() => import("./pages/HealthAssessmentQuiz"));
const HealthQuestionnaire = lazy(() => import("./pages/HealthQuestionnaire"));
const CompleteAnalysis = lazy(() => import("./pages/CompleteAnalysis"));
const Appointment = lazy(() => import("./pages/Appointment"));
const Doshas = lazy(() => import("./pages/Doshas"));
const Prakriti = lazy(() => import("./pages/Prakriti"));
const ThanksAppointment = lazy(() => import("./pages/ThanksAppointment"));

const Loader = lazy(() => import("./components/loader/Loader"));
const NoMatchPage = lazy(() => import("./pages/NoMatchPage"));
function App() {
 const [loading, setLoading] = useState(false);
  useEffect(() => {
    setLoading(true); // Start loading
    const timer = setTimeout(() => setLoading(false), 1000); // Simulate loading delay
    return () => clearTimeout(timer);
  }, []); // Runs on route change
  
  return (

   <Router>
    {loading && <Loader />}
    <Routes>
      <Route exact  path ="/" element={<LoginRegisterComp/>}></Route>
	    <Route exact  path ="/health-assessment-quiz" element={<HealthAssessmentQuiz/>}></Route>
	    <Route exact  path ="/health-questionnaire" element={<HealthQuestionnaire/>}></Route>
      <Route exact  path ="/complete-analysis" element={<CompleteAnalysis/>}></Route>
      <Route exact  path ="/appointment" element={<Appointment/>}></Route>
      <Route exact  path ="/doshas" element={<Doshas/>}></Route>
      <Route exact  path ="/prakriti" element={<Prakriti/>}></Route>
      <Route exact  path ="/thanks-appointment" element={<ThanksAppointment/>}></Route>
	   <Route path="*" element={<NoMatchPage/>}></Route>
     </Routes>
    </Router>
  );
}

export default App;
